// frontend/src/components/Header.js
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../services/authService";

const Header = ({ user, title }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <nav className="main-header navbar navbar-expand navbar-dark navbar-navy">
      <div className="container-fluid">
        <Link to="/" className="navbar-brand">
          <img
            src="https://person.ssk3.go.th/wp-content/uploads/2023/12/%E0%B8%95%E0%B8%A3%E0%B8%B2%E0%B9%80%E0%B8%82%E0%B8%95-3-removebg-preview.png"
            alt="SSK3 Logo"
            className="brand-image img-circle elevation-3"
            style={{ opacity: ".8", height: "36px" }}
          />
          <span className="brand-text font-weight-light ml-2">
            ระบบ SSK3 ITA
          </span>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link to="/profile" className="nav-link">
                <i className="fas fa-user"></i>{" "}
                {user ? user.name : "บัญชีผู้ใช้"}
              </Link>
            </li>
            <li className="nav-item">
              <button onClick={handleLogout} className="btn nav-link">
                <i className="fas fa-sign-out-alt"></i> ออกจากระบบ
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
